/* rxlib - TreePermissoes v2.0.1 */

import React from 'react';
import Checkbox from '../checkbox';
import Tree from 'react-animated-tree';

import {
    Acesso,
    Direito,
    PerfilUsuario,
} from '../../../services/tipos';

interface TreePermissoesProps {
    permissoes: Direito[];
    naoPodeEditar: boolean;
    perfilPermissao: Acesso[];
    idPerfilSelecionao: string;
    perfilsUsuario: PerfilUsuario[];
    onChange: (e: React.FormEvent<HTMLInputElement>) => void;
}

export function TreePermissoes(props: TreePermissoesProps) {
    let gruposListados: string[] = [];

    return (
        <div>
            {
                props.permissoes.map((grupos) =>
                    !gruposListados.includes(grupos.grupo)
                        ? <Tree
                            content={grupos.grupo}
                            key={gruposListados.indexOf(grupos.grupo)}>
                            <div className='d-none'>
                                {gruposListados.push(grupos.grupo)}
                            </div>
                            {
                                props.permissoes
                                    .filter((permissao) => permissao.grupo === grupos.grupo)
                                    .map((permissao, index) =>
                                        <div key={permissao.id} className='rxlib-checkbox-permissao'>
                                            <Checkbox
                                                value={permissao.id}
                                                text={permissao.nome}
                                                onChange={props.onChange}
                                                name={'permissoes.' + index}
                                                referencia={React.createRef()}
                                                defaultChecked={!!props.perfilPermissao.find(permissaoPerfil => permissaoPerfil.idDireito === permissao.id)}
                                                disabled={
                                                    props.perfilsUsuario
                                                        .find(perfilUsuario => perfilUsuario.idPerfil === props.idPerfilSelecionao)
                                                        ? true
                                                        : props.naoPodeEditar
                                                            ? true
                                                            : false
                                                } />
                                        </div>
                                    )
                            }
                        </Tree>
                        : null
                )
            }
        </div>
    );
}